<div >
  <ng-container *ngIf="notificationItem.url.length > 0; else noItemLink">
    <ng-container *ngIf="!notificationItem.isExterno; else externalLink">
      <a [routerLink]="['/'].concat(notificationItem.url.replace(notificationItem.url.split('#')[1],'').replace('#','').split('/'))" 
        [fragment]="notificationItem.url.split('#')[1]">
        <h5 style="margin: 4px;">{{notificationItem.nombre}}</h5>
      </a>
    </ng-container>
    <ng-template #externalLink>
      <a href="{{notificationItem.url}}">
        <h5 style="margin: 4px;">{{notificationItem.nombre}}</h5>
      </a>
    </ng-template>
  </ng-container>
  <ng-template #noItemLink>
    <h5>{{notificationItem.nombre}}</h5>
  </ng-template>
  <div style="font-size: 14px; align-items: center; opacity: .6; display: flex;">
    <mat-icon style="margin-right: 4px;" class="md-14">calendar_today</mat-icon>
    <p class="inline-flex">{{notificationItem.fecha}}</p>
    <mat-icon style="margin-right: 4px;" class="md-14" *ngIf="notificationItem.hora.length > 0">access_time</mat-icon>
    <p class="inline-flex" *ngIf="notificationItem.hora.length > 0">{{notificationItem.hora}}</p>
  </div>
  <div class="flex-wrap" style="font-size: 14px; align-items: center;  opacity: .6;"
       *ngIf="notificationItem.lugar.length > 0">
    <mat-icon style="margin-right: 4px;" class="md-14">location_on</mat-icon>
    <p class="inline-flex">{{notificationItem.lugar}}</p>
    <mat-icon style="margin-right: 4px;" class="md-14" *ngIf="notificationItem.cantidad && notificationItem.cantidad.length > 0">people</mat-icon>
    <p class="inline-flex" *ngIf="notificationItem.cantidad && notificationItem.cantidad.length > 0">{{notificationItem.cantidad}}</p>
  </div>
  <mat-chip *ngIf="false"></mat-chip>
</div>
